import MoveTo from 'moveTo'

export default {
  init() {
    const products = document.querySelectorAll('.header-menu-item a')

    products.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()
        const moveTo = new MoveTo({ tolerance: 80 })
        const div = document.querySelector(element.getAttribute('href'))
        moveTo.move(div)
      })
    })
  },
  finalize() {},
}
